import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { OrderProvider } from "./context/OrderContext";

import HomePage from "./pages/HomePage";
import FlavorsPage from "./pages/FlavorsPage";
import OrderPage from "./pages/OrderPage";
import CustomOrdersPage from "./pages/CustomOrdersPage";
import RewardsPage from "./pages/RewardsPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import OrderConfirmPage from "./pages/OrderConfirmPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import OrderReceiptPage from "./pages/OrderReceiptPage";
import ReviewsPage from "./pages/ReviewsPage";

import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminOrders from "./admin/AdminOrders";
import AdminFlavors from "./admin/AdminFlavors";
import AdminAnnouncements from "./admin/AdminAnnouncements";
import AdminCustomOrders from "./admin/AdminCustomOrders";
import AdminMessages from "./admin/AdminMessages";
import AdminSettings from "./admin/AdminSettings";
import AdminPickupEmail from "./admin/AdminPickupEmail";
import AdminNotify from "./admin/AdminNotify";
import AdminUsers from "./admin/AdminUsers";
import AdminPromoCodes from "./admin/AdminPromoCodes";

function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(loc.pathname)}`} replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <OrderProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/flavors" element={<FlavorsPage />} />
              <Route path="/order" element={<OrderPage />} />
              <Route path="/order/confirm" element={<OrderConfirmPage />} />
              <Route path="/orders" element={<MyOrdersPage />} />
              <Route path="/orders/:orderNumber" element={<OrderReceiptPage />} />
              <Route path="/custom-orders" element={<CustomOrdersPage />} />
              <Route path="/rewards" element={<RewardsPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />

              <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
                <Route index element={<AdminDashboard />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="promo-codes" element={<AdminPromoCodes />} />
                <Route path="flavors" element={<AdminFlavors />} />
                <Route path="announcements" element={<AdminAnnouncements />} />
                <Route path="pickup-email" element={<AdminPickupEmail />} />
                <Route path="notify" element={<AdminNotify />} />
                <Route path="custom-orders" element={<AdminCustomOrders />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </OrderProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
